export const API_NAME_WORKFLOW = 'Workflow';
export const API_NAME_USER = 'User';
export const API_NAME_CREDIT_CONTROL = 'CreditControl';
